import { makeStyles } from "@material-ui/core/styles";

export const SideBannerJss = makeStyles(theme => ({
  icon: {
    width: '30px !important',
    height: '30px !important',
    stroke: '#8544F6 !important',
    position: 'relative'
  },
  search: {
    top: '12px',
    marginRight: '8px',
  },
  bag: {
    top: '10px',
    marginLeft: '8px'
  },
  headWrap:{
    paddingLeft: theme.spacing(4),
    paddingBottom: theme.spacing(6),
  },
  head: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#8544F6',
    borderBottom: '2px solid #8544F6',
    cursor: 'pointer',
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(8)
  }, 
  headBig: {
    fontSize: '2rem',
    fontWeight: 'bold',
    paddingBottom: theme.spacing(3)
  },
  headBigColor: {
    color: 'rgb(255, 0, 149)',
  },
  onHead:{
    fontSize: '1.2rem',
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(3),
    fontWeight: 'bold',
  },
  headLittle:{
    fontSize: '1.1rem',
  },
  mainContainer: {
    background: theme.palette.white.main,
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      width:'100%',
      background: theme.palette.white.main,
    },
  },
  iconContainer: {
    '& .MuiSvgIcon-root': {
      fontSize: '5rem',
    },
  },
  marketLogoContainer: {
    marginTop: theme.spacing(12),
    '& .MuiSvgIcon-root': {
      width: 163,
      height: 126,
      marginLeft: theme.spacing(4),
      marginBottom: theme.spacing(8),
      [theme.breakpoints.down("sm")]: {
        width: 88,
        height: 67,
        marginLeft: theme.spacing(4),
        marginBottom: theme.spacing(2),
      },
    },
  },
  subtitleTypography: {
    fontSize:'1.5rem',
    [theme.breakpoints.down("sm")]: {
      fontSize:'1.125rem',
    },
  },
  listItemTextRegular: {
    color: '#000000',
    fontSize:'1rem',
    fontWeight: '500',
    [theme.breakpoints.down("md")]: {
      fontSize:'1rem',
    },
  },
  headerRegularText: {
    color: '#000000',
    fontSize:'1.2rem',
    marginLeft: theme.spacing(4),
    fontWeight: '600',
    [theme.breakpoints.down("md")]: {
      fontSize:'1.1rem',
    },
  },
  list: {
    paddingTop: theme.spacing(5),
    '& .MuiListItem-gutters': {
      padding: theme.spacing(0),
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .MuiAvatar-root': {
      height: '3.5rem',
      width: '3.5rem',
      background: 'transparent',
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      '& .MuiSvgIcon-root': {
        height: '0.7em'
      }
    }
  },
  sideBannerTextButton: {
    textTransform: 'none',
    bottom: '82px',
    '@media all and (min-width:0px) and (max-width: 959px)': {
      bottom: '2px',
    },
    fontFamily: 'Barlow',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '17px',
    color: '#6A148E',
    width: '100%',
    '& .MuiButton-endIcon': {
      marginBottom: '-15px',
      marginLeft: '0px',
      transform: 'scale(0.7)',
    }
  }
}));
